module.exports = __webpack_public_path__ + "filerobot/filerobot-image-editor.min.js";